<script lang="ts">
    import { fly, fade, slide, blur, scale } from 'svelte/transition'
    import { onMount } from 'svelte'

    export let footer: boolean = false
    export let maxWidth: string = '1600px'

    const isMobile = screen.width <= 900
    let visible = !isMobile
    const effect = (node, options) => {
        if (isMobile) {
            return options.fn(node, options)
        }
    }
    onMount(() => {
        visible = true
    })
</script>

{#if visible}
    <div transition:effect={{ fn: blur }} style={!!maxWidth ? 'max-width:' + maxWidth + ';' : ''}>
        <slot />
        {#if footer}
            <div class="footer"></div>
        {/if}
    </div>
{/if}

<style>
    div {
        margin: 0 auto;
        padding-bottom: 16px;
        width: 100%;
        max-width: 1600px;
        padding: 0px;
        height: 100%;
        flex-grow: 1;
        position: relative;
    }

    .footer {
        height: 90px;
        width: 100%;
        z-index: -1;
    }
</style>
